import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../store/root-reducer';
import {
  DeleteRevokeInframailIpsRequest,
  GetInframailIpsRequest,
  InframailPaginationMeta,
} from '../../types';
import {
  deleteRevokeInframailIpsRequest,
  getInframailIpsDomainsRequest,
  getInframailIpsRequest,
} from '../../extra-actions';
import {
  resetDeleteRevokeInframailIpsRequestState,
  resetGetInframailIpsDomainsRequestState,
  resetGetInframailIpsRequestState,
  updateInframailIpsMeta,
} from '../../inframail-ips-slice';

import InframailIpsContent from './inframail-ips-content';
import {
  setEmailAccountInfrastructureDedicatedIpsCount,
  setSelectedDomainsForNewEmailAccounts,
} from '../../../email-accounts/email-accounts-slice';
import { SelectedDomainsForNewEmailAccounts } from '../../../email-accounts/types/create-email-infrastructure';

const mapStateToProps = (state: RootState) => ({
  inframailIps: state.inframailIps.inframailIps,
  inframailIpsDomains: state.inframailIps.inframailIpsDomains,
  inframailIpsMeta: state.inframailIps.inframailIpsMeta,

  getInframailIpsRequestStatus:
    state.inframailIps.getInframailIpsRequest.status,
  getInframailIpsRequestError: state.inframailIps.getInframailIpsRequest.error,

  getInframailIpsDomainsRequestStatus:
    state.inframailIps.getInframailIpsDomainsRequest.status,
  getInframailIpsDomainsRequestError:
    state.inframailIps.getInframailIpsDomainsRequest.error,

  deleteRevokeInframailIpsRequestStatus:
    state.inframailIps.deleteRevokeInframailIpsRequest.status,
  deleteRevokeInframailIpsRequestError:
    state.inframailIps.deleteRevokeInframailIpsRequest.error,
});

const mapDispatchToProps = {
  sendGetInframailIpsRequest: (payload: GetInframailIpsRequest) =>
    getInframailIpsRequest(payload),
  resetGetInframailIpsRequestState: () => resetGetInframailIpsRequestState(),

  sendGetInframailIpsDomainsRequest: (hostId: string) =>
    getInframailIpsDomainsRequest(hostId),
  resetGetInframailIpsDomainsRequestState: () =>
    resetGetInframailIpsDomainsRequestState(),

  sendDeleteRevokeInframailIpsRequest: (
    payload: DeleteRevokeInframailIpsRequest,
  ) => deleteRevokeInframailIpsRequest(payload),
  resetDeleteRevokeInframailIpsRequestState: () =>
    resetDeleteRevokeInframailIpsRequestState(),

  updateInframailIpsMeta: (meta: InframailPaginationMeta) =>
    updateInframailIpsMeta(meta),

  setEmailAccountInfrastructureDedicatedIpsCount: (count: number) =>
    setEmailAccountInfrastructureDedicatedIpsCount(count),

  setSelectedDomainsForNewEmailAccounts: (
    payload: SelectedDomainsForNewEmailAccounts,
  ) => setSelectedDomainsForNewEmailAccounts(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(InframailIpsContent);
